export enum EmptyStateTypeEnum {
  BARCODE = 'barcode',
  VIEW_DOCUMENT = 'view-document',
  DOCUMENTS_LIST = 'documents-list',
}
